<div class="zf-pick">
  <div class="zf-pick-card">
    <div class="zf-pick-head">
      <h2>Select a store or warehouse</h2>
      <p>You have access to multiple locations. Choose which one to work in — stock and documents will be shown for this location. You can switch later from the top bar.</p>
    </div>
    <div class="zf-pick-list">
      @for (access of storeAccess; track access.storeId) {
        <button type="button" class="zf-pick-row" (click)="select(access)">
          <span class="zf-pick-icon" [class.store]="access.locationType !== 'Warehouse'">
            <i class="bi" [class.bi-shop]="access.locationType !== 'Warehouse'"
               [class.bi-box-seam]="access.locationType === 'Warehouse'"></i>
          </span>
          <span class="zf-pick-main">
            <span class="zf-pick-name">{{ access.locationName || access.storeName || access.storeCode }}</span>
            <span class="zf-pick-code">{{ access.storeCode }}</span>
          </span>
          <span class="zf-tag" [class.primary]="access.locationType === 'Warehouse'"
                [class.ok]="access.locationType !== 'Warehouse'">{{ access.locationType || 'Store' }}</span>
          <span class="zf-arrow"><i class="bi bi-chevron-right"></i></span>
        </button>
      }
    </div>
  </div>
</div>
